module.exports = __webpack_public_path__ + "img/image2.78ff6a03.png";